// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1ca8x","insightsList":"newBusinessInsightsMenu_insightsList__Jzrnd","active":"newBusinessInsightsMenu_active__nAROX"};